import { render, staticRenderFns } from "./ClientLevel.vue?vue&type=template&id=c925e0f2&"
import script from "./ClientLevel.vue?vue&type=script&lang=js&"
export * from "./ClientLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports